import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import { MdDeleteForever } from "react-icons/md";
import { FaEdit, FaHeart, FaUser, FaShoppingBag, FaStar, FaArrowAltCircleRight } from "react-icons/fa";
import AddAddress from "../components/AddAddress";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

export default function AccountPage() {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;

    const customerType = localStorage.getItem("CustomerType");
    const LedName = localStorage.getItem("LedName");
    const AgentCode = localStorage.getItem("AgentCode");
    const ledcode = localStorage.getItem("Ledcode");
    const ledname = localStorage.getItem("LedName");
    const ledemail = localStorage.getItem("LedEmail");
    const navigate = useNavigate();

    const user = {
        name: customerType,
        LedName: LedName,
        AgentCode: AgentCode,
        Ledcode: ledcode,
        email: "email@example.com",
        phone: "+91 9876543210",
        address: "Perinthalmanna, Malappuram",
    };

    const [isEditing, setIsEditing] = useState(false);
    const [editedAddress, setEditedAddress] = useState({});
    const [addressList, setAddressList] = useState([]);
    const [selectedAddressId, setSelectedAddressId] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [selected, setSelected] = useState("info");

    const [wishlist, setWishlist] = useState([]);

    const navItems = [
        { id: "info", label: "My Info", icon: <FaUser /> },
        { id: "orders", label: "Orders", icon: <FaShoppingBag /> },
        { id: "wishlist", label: "Wishlist", icon: <FaHeart /> },
    ];

    const visibleNavItems = customerType === "CUSTOMER" ? navItems : navItems.filter((item) => item.id === "info");

    const [quantities, setQuantities] = useState({});
    const [selectedVariant, setSelectedVariant] = useState("");

    const handleAddToCart = (productId) => {
        console.log(productId);
        const product = wishlist.find((p) => p.ID === productId);
        console.log(product);

        if (!product) {
            console.error("❌ Product not found for ID:", productId);
            toast.error("Product not found. Please refresh the page.");
            return;
        }

        addToCart(product);
    };

    const addToCart = async (product) => {
        const quantity = quantities[product.ID];

        if (quantity === "" || !/^\d+$/.test(quantity) || Number(quantity) <= 0) {
            toast.error("Please enter a valid quantity");
            return;
        }

        const qtyNumber = Number(quantity);
        const existingData = JSON.parse(localStorage.getItem("productData")) || [];

        // const index = existingData.findIndex((item) => item.id === product.ID);
        const index = existingData.findIndex((item) => item.id === product.ID && item.selectedVariant === selectedVariant);

        let quantityDifference = qtyNumber;
        let uniqueCode = generateUniqueCode();
        // let uniqueCode = "0";

        if (index !== -1) {
            const updatedQuantity = existingData[index].quantity + qtyNumber;
            if (updatedQuantity > product.Qty) {
                toast.error(`Total quantity exceeds stock (${product.Qty})`);
                return;
            }

            // Keep old code
            uniqueCode = existingData[index].uniqueCode;

            existingData[index].quantity = updatedQuantity;
        } else {
            if (qtyNumber > product.Qty) {
                toast.error(`Available stock is ${product.Qty}`);
                return;
            }

            existingData.push({
                itemName: product.ItemName,
                id: product.ID,
                mop: product.MOP,
                dp: product.DP,
                ap: product.AP,
                mrp: product.MRP,
                branch: product.Branch,
                realpratetax: product.RealPrateTax,
                quantity: qtyNumber,
                uniqueCode,
                selectedVariant, // Track variant in local storage
            });
        }

        // Save to localStorage
        localStorage.setItem("productData", JSON.stringify(existingData));

        const price = getNumericPrice(product);

        // Send to API
        try {
            const payload = {
                itemId: product.ID,
                uniqueCode, // Use the correct one
                itemName: product.ItemName,
                itemPrice: price,
                quantity: quantityDifference,
                ledname,
                ledcode,
                ledemail: ledemail || "no email",
            };
            console.log("Payload to API:", payload);

            const res = await axios.post(`${apiBaseUrl}/cart/add/JAPAN_ACCESORIES`, payload);

            console.log("API Response:", res.data);

            if (res.data.success) {
                toast.success("Item added to cart");
            } else {
                toast.error("Failed to sync with server");
            }
        } catch (err) {
            // console.error("Add to cart error:", err);
            // toast.error("Server error: unable to sync cart");
            console.error("Add to cart error:", err?.response?.data || err.message || err);
            toast.error("Server error: unable to sync cart");
        }

        setQuantities((prev) => ({ ...prev, [product.ID]: "" }));
    };

    useEffect(() => {
        fetchAddresses();
    }, [apiBaseUrl]);

    const generateUniqueCode = () => {
        return (
            Date.now().toString(36) + // Timestamp in base36
            Math.random().toString(36).substring(2, 8).toUpperCase() // Random 6 chars
        );
    };

    const getNumericPrice = (product) => {
        switch (customerType) {
            case "CUSTOMER":
                return product.MOP ?? product.MRP;
            case "AGENT":
                return product.AP ?? product.MRP;
            case "DEALER":
                return product.DP ?? product.MRP;
            case "JS_EMPLOYEE":
            case "TK_EMPLOYEE":
            case "JS_MANAGER":
            case "TK_MANAGER":
                return product.MRP;
            default:
                return product.MRP;
        }
    };

    const handleQuantityChange = (productId, value) => {
        setQuantities((prev) => ({
            ...prev,
            [productId]: value,
        }));
    };

    const fetchAddresses = async () => {
        if (!ledcode) return;
        try {
            const response = await fetch(`${apiBaseUrl}/user/getAddresses/${ledcode}/JAPAN_ACCESORIES`);
            const result = await response.json();
            const addresses = Array.isArray(result) ? result : Array.isArray(result.data) ? result.data : [];
            setAddressList(addresses);
            if (addresses.length > 0) {
                setSelectedAddressId(addresses[0].id);
            }
        } catch (err) {
            console.error("Error fetching address list:", err);
            setAddressList([]);
        }
    };

    const updateAddress = async (addressId, updatedData) => {
        try {
            const response = await fetch(`${apiBaseUrl}/user/updateAddress/${addressId}/JAPAN_ACCESORIES`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(updatedData),
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.message || "Failed to update address.");
            return result;
        } catch (error) {
            console.error("Error updating address:", error);
            throw error;
        }
    };

    const handleSave = async () => {
        try {
            await updateAddress(selectedAddressId, editedAddress);
            setIsEditing(false);
            fetchAddresses();
        } catch (error) {
            alert("Failed to save address.");
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditedAddress((prev) => ({ ...prev, [name]: value }));
    };

    const deleteAddress = async (addressId) => {
        try {
            const response = await fetch(`${apiBaseUrl}/user/deleteAddress/JAPAN_ACCESORIES`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    addressId: addressId,
                    ledcode: ledcode, // ledcode from localStorage
                }),
            });

            const result = await response.json();
            if (!response.ok) throw new Error(result.message || "Failed to delete address.");
            return result;
        } catch (error) {
            console.error("Error deleting address:", error);
            throw error;
        }
    };

    const handleRemove = async (id) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this address?");
        if (!confirmDelete) return;

        try {
            await deleteAddress(id);
            fetchAddresses();
            if (selectedAddressId === id) setSelectedAddressId(null);
        } catch (err) {
            alert("Failed to delete address: " + err.message);
        }
    };

    const setActiveAddress = async (addressId) => {
        try {
            const response = await fetch(`${apiBaseUrl}/user/setActiveAddress/JAPAN_ACCESORIES`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ addressId, ledcode }),
            });

            const result = await response.json();
            if (!response.ok) throw new Error(result.message || "Failed to set active address.");
            return result;
        } catch (error) {
            console.error("Error setting active address:", error);
            throw error;
        }
    };

    const handleSelect = async (id) => {
        try {
            await setActiveAddress(id); // Set on server
            setSelectedAddressId(id); // Update UI
            setIsEditing(false);
            setEditedAddress({});
        } catch (err) {
            alert("Failed to set active address.");
        }
    };

    const selectedAddress = addressList.find((addr) => addr.id === selectedAddressId);

    const fullimage = (itemId, ID, customerType) => {
        navigate(`/fullimage/${itemId}/${ID}/${customerType}`);
    };

    const renderPriceInfo = (product) => {
        if (!customerType) {
            return <span id="h3">MRP: ₹ {product.MRP}</span>;
        }

        switch (customerType) {
            case "CUSTOMER":
                return (
                    <div className="flex flex-row justify-between items-center w-full gap-2">
                        <div>
                            <div id="h3">MOP: ₹ {product.MOP}</div>
                            <div id="h3">MRP: ₹ {product.MRP}</div>
                        </div>
                        {/* <div>
                            <span className="text-[#d1d5db] font-normal text-sm">₹ </span>
                            <span className="text-[#d1d5db] line-through font-normal text-sm">{product.MRP}</span>
                        </div> */}
                    </div>
                );
            case "AGENT":
                return (
                    <div className="flex flex-row justify-between items-center w-full gap-2">
                        <div>
                            <div id="h3">AP: ₹ {product.AP}</div>
                            <div id="h3">MOP: ₹ {product.MOP}</div>
                        </div>

                        <div id="h3">MRP: ₹ {product.MRP}</div>
                    </div>
                );
            case "DEALER":
                // return <span id="h3">DP: ₹ {product.DP}</span>;
                return (
                    <div className="flex flex-row justify-between items-center w-full gap-2">
                        <div>
                            <div id="h3">DP: ₹ {product.DP}</div>
                            <div id="h3">MOP: ₹ {product.MOP}</div>
                        </div>

                        <div id="h3">MRP: ₹ {product.MRP}</div>
                    </div>
                );
            case "JS_EMPLOYEE":
            case "TK_EMPLOYEE":
                return (
                    <div className="flex flex-row justify-between items-center w-full gap-2">
                        <div>
                            <div id="h3">Branch: {product.Branch}</div>
                            <div id="h3">MRP: ₹ {product.MRP}</div>
                        </div>
                    </div>
                );
            case "JS_MANAGER":
            case "TK_MANAGER":
                return (
                    <div className="flex flex-row justify-between items-center w-full gap-2">
                        <div>
                            <div id="h3">Rate: ₹{product.RealPrateTax}</div>
                            <div id="h3">MRP: ₹ {product.MRP}</div>
                        </div>
                    </div>
                );
            default:
                return (
                    <div className="flex flex-row justify-between items-center w-full gap-2">
                        {/* <span id="h3">MOP: ₹ {product.MOP}</span>
                        &nbsp;&nbsp;&nbsp;&nbsp; */}
                        <div id="h3">MRP: ₹ {product.MRP}</div>
                    </div>
                );
        }
    };

    useEffect(() => {
        const fetchWishlist = async () => {
            const ledcode = localStorage.getItem("Ledcode");
            try {
                const res = await axios.get(`${apiBaseUrl}/wishlist/items/JAPAN_ACCESORIES/${ledcode}`);

                if (res.data.success && Array.isArray(res.data.items)) {
                    setWishlist(res.data.items);
                }
            } catch (err) {
                console.error("Fetch wishlist error:", err);
            }
        };

        fetchWishlist();
    }, [apiBaseUrl]);

    const removeFromWishlist = async (productId) => {
        try {
            const res = await axios.delete(`${apiBaseUrl}/wishlist/delete/JAPAN_ACCESORIES/${productId}`);

            if (res.data.success) {
                // Remove from local state
                setWishlist((prev) => prev.filter((item) => item.ID !== productId));
                toast.success("Removed from wishlist!");
            } else {
                toast.error("Failed to remove from wishlist");
            }
        } catch (error) {
            console.error("Wishlist remove error:", error);
            toast.error("Error removing from wishlist");
        }
    };

    return (
        <div className="min-h-screen flex flex-col  flex-1 pb-5 ">
            <div className="sticky top-0 z-50">
                <Navbar />
            </div>
            <div className="max-w-full md:mx-[10%] grid grid-cols-1 md:grid-cols-4 gap-6 md:mt-6">
                {/* Sidebar */}
                <div className=" pr-4">
                    <ul className="flex flex-row justify-around md:flex-col md:space-y-4 md:space-x-0 text-sm font-medium w-full md:w-fit z-10 bg-[white] p-3 fixed gap-7 md:gap-0">
                        <div className="hidden mb-5 md:flex gap-5">
                            <div className="h-15 w-2 bg-[#8B0000] rounded-full"></div>
                            <div>
                                <h2 className="text-xl font-medium ">Hello {user.name}</h2>
                                <p className="font-normal text-[#999a9a]">Welcome to your account</p>
                            </div>
                        </div>
                        {visibleNavItems.map((item) => (
                            <li
                                key={item.id}
                                onClick={() => setSelected(item.id)}
                                className={`flex items-center gap-2 cursor-pointer p-2 ${
                                    selected === item.id
                                        ? "md:border-l-4 border-[#8B0000] text-[#8B0000] font-semibold bg-[#d9d9da] md:bg-[#f3f4f6] rounded md:w-[60%]"
                                        : "text-[#374151]"
                                }`}
                            >
                                {item.icon} {item.label}
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Content */}
                <div className="md:col-span-3 mx-[5%] md:mx-0">
                    {/* Orders  */}
                    {selected === "orders" && (
                        <div className="md:col-span-3 bg-[#e4dddd] rounded mt-12 md:mt-0">
                            <div className="flex">
                                <h3 className="text-lg font-semibold p-4">Orders</h3>
                            </div>
                        </div>
                    )}

                    {/* Wishlist */}
                    {selected === "wishlist" && (
                        <div className="md:col-span-4 rounded mt-12 md:mt-0">
                            {wishlist.length === 0 ? (
                                <div className="width-full flex justify-center items-center h-[10vh]">
                                    <span className="text-xl font-[500] font-display text-[#c61c1c]">
                                        Wish List is Empty
                                    </span>
                                </div>
                            ) : (
                                <div className="w-full md:px-4 sm:px-28 py-2 ">
                                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4 w-full ">
                                        {wishlist.map((product, index) => (
                                            <div
                                                key={product.ID}
                                                className="product-card w-full flex flex-col rounded-md border-[#d1d5db] shadow-xl bg-[white] my-2"
                                            >
                                                <div
                                                    // onClick={() => fullimage(product.ItemName, product.ID, customerType)}
                                                    className="relative group w-full lg:h-[313px] md:h-[270px] sm:h-[250px] h-[200px] flex flex-col justify-center items-center bg-[white] rounded-[10px] gap-[2%] cursor-pointer overflow-hidden"
                                                >
                                                    <button
                                                        onClick={() => removeFromWishlist(product.ID, ledcode)}
                                                        className="absolute top-3 right-3 hover:text-[#d1d5db] text-[red]"
                                                    >
                                                        <MdDeleteForever size={20} />
                                                    </button>
                                                    <div
                                                        onClick={() =>
                                                            fullimage(product.ItemName, product.ID, customerType)
                                                        }
                                                        className="w-[68%] h-[68%] flex justify-center items-center "
                                                    >
                                                        <img
                                                            src={`${apiLocalUrl}/uploads/${product.ID}.jpg?v=${Date.now()}`}
                                                            alt="carcharger"
                                                            className="size-[100%] object-contain mix-blend-multiply"
                                                        />
                                                    </div>

                                                    {/* Add to Cart Button*/}
                                                    <div className=" w-full text-center">
                                                        <div className="mx-4 bg-gradient-to-r from-[#8b0000] to-[#d78e8e] rounded text-[white] p-2 flex items-center justify-center">
                                                            <div className="flex">
                                                                <span className="text-lg font-medium">🛒</span>
                                                                <span className=" hidden md:flex lg:text-md sm:text-sm text-xs font-medium items-center">
                                                                    Add to Cart
                                                                </span>
                                                            </div>

                                                            <input
                                                                type="text"
                                                                min="1"
                                                                value={quantities[product.ID] || ""}
                                                                onChange={(e) =>
                                                                    handleQuantityChange(product.ID, e.target.value)
                                                                }
                                                                // onBlur={() => handleBlur(product.ID)}
                                                                className="md:w-12 w-10 px-1 py-0.5 text-[black] rounded  mx-1 lg:text-md sm:text-sm text-xs font-medium"
                                                            />
                                                            <span
                                                                role="button"
                                                                onClick={() => handleAddToCart(product.ID)}
                                                                className="cursor-pointer hover:underline"
                                                            >
                                                                <FaArrowAltCircleRight className="md:size-6 size-5" />
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                    onClick={() => fullimage(product.ItemName, product.ID, customerType)}
                                                    className="w-full md:h-[25vh] h-auto flex flex-col items-start py-2 gap-1 px-4 rounded-b-[10px] bg-[white]"
                                                >
                                                    <p className="text-sm text-[#a4a7ab] mb-1">Category</p>
                                                    <span className="lg:text-md sm:text-sm text-xs font-medium text-left w-[70%]">
                                                        {product.ItemName}
                                                    </span>
                                                    {/* Rating */}
                                                    {/* <div className="flex gap-1 ">
                                                        {[...Array(5)].map((_, i) => (
                                                            <FaStar key={i} className="text-[#FACC15] text-sm" />
                                                        ))}
                                                    </div> */}

                                                    <div className="flex flex-row justify-between items-center w-full gap-2">
                                                        <span className="lg:text-md sm:text-sm text-xs text-[#2563EB] font-semibold text-left w-full">
                                                            {renderPriceInfo(product)}
                                                        </span>
                                                        <span className="text-[#d1d5db] text-sm">₹</span>
                                                        <span className="text-[#d1d5db] line-through text-sm">
                                                            {product.MRP}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Info  */}
                    {selected === "info" && (
                        <div className="md:col-span-3 space-y-12 md:space-y-0">
                            <div className="fixed top-32 md:right-48 z-50 w-[90%] lg:w-[54%] lg:mt-10">
                                {showForm && (
                                    <AddAddress
                                        onAdd={() => {
                                            setShowForm(false);
                                        }}
                                        onCancel={() => setShowForm(false)}
                                    />
                                )}
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                {["name", "mobile", "address", "locality", "city", "district", "pincode"].map((field) => (
                                    <input
                                        key={field}
                                        name={field}
                                        value={isEditing ? editedAddress[field] || "" : selectedAddress?.[field] || ""}
                                        onChange={handleChange}
                                        placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
                                        disabled={!isEditing}
                                        className={`border border-[#b8b8b9] p-2 rounded w-full ${
                                            !isEditing ? "cursor-not-allowed" : "bg-[#efefef]"
                                        }`}
                                    />
                                ))}
                                <select
                                    name="addressType"
                                    value={isEditing ? editedAddress.addressType || "" : selectedAddress?.addressType || ""}
                                    onChange={handleChange}
                                    disabled={!isEditing}
                                    className={`border border-[#b8b8b9] p-2 rounded w-full ${
                                        !isEditing ? "cursor-not-allowed bg-[#f9f9f9]" : "bg-[#efefef]"
                                    }`}
                                >
                                    <option value="">Select Address Type</option>
                                    <option value="Home">Home</option>
                                    <option value="Office">Office</option>
                                    <option value="Other">Other</option>
                                </select>
                                <div className="md:col-span-2 flex justify-end gap-4 mb-2">
                                    {!isEditing ? (
                                        <button
                                            onClick={() =>
                                                selectedAddress &&
                                                setEditedAddress({ ...selectedAddress }) & setIsEditing(true)
                                            }
                                            className="flex items-center gap-2 border-2 text-[#663dee] px-4 py-2 rounded text-sm font-semibold"
                                        >
                                            Edit <FaEdit />
                                        </button>
                                    ) : (
                                        <>
                                            <button
                                                onClick={handleSave}
                                                className="border-2 text-[#663dee] px-4 py-2 rounded text-sm font-semibold"
                                            >
                                                Save
                                            </button>
                                            <button
                                                onClick={() => setIsEditing(false)}
                                                className="border-2 text-[#8B0000] px-4 py-2 rounded text-sm font-semibold"
                                            >
                                                Cancel
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>

                            {/* Billing Address */}
                            <div className="mt-10">
                                <div className="flex justify-between items-center mb-4">
                                    <h3 className="text-lg font-semibold">Billing Address</h3>
                                    <div className="flex">
                                        <button
                                            type=""
                                            onClick={() => setShowForm(true)}
                                            className=" items-center border-2 font-medium text-[#BB002D] rounded text-sm px-3 py-1"
                                        >
                                            <span>Add New Address</span>
                                        </button>
                                    </div>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    {addressList.map((item) => (
                                        <label
                                            key={item.id}
                                            htmlFor={`address-${item.id}`}
                                            className={`cursor-pointer block border-2 rounded-md p-4 ${
                                                selectedAddressId === item.id ? "border-[#8e8e90]" : "border-[#EAEAEC]"
                                            }  rounded-md p-4`}
                                        >
                                            {/* Hidden radio button */}
                                            <input
                                                type="radio"
                                                id={`address-${item.id}`}
                                                name="selectedAddress"
                                                checked={selectedAddressId === item.id}
                                                onChange={() => handleSelect(item.id)}
                                                className="hidden"
                                            />

                                            {/* Address Header */}
                                            <div className="flex items-center gap-2 mb-2">
                                                <p className="font-bold text-lg  text-[#444]">{item.name}</p>
                                                <p className="border-2 font-semibold text-sm rounded-full px-3 text-[#444]">
                                                    {item.addressType}
                                                </p>
                                            </div>

                                            {/* Address Text */}
                                            <div className="text-sm text-[#333] ml-1">
                                                <p className="font-medium mb-1">
                                                    {[
                                                        item.address,
                                                        item.locality,
                                                        item.city,
                                                        item.district,
                                                        item.state,
                                                        item.pincode,
                                                    ]
                                                        .filter(Boolean)
                                                        .join(", ")}
                                                </p>
                                                <div className="flex">
                                                    <p className="text-[#878787] font-medium">Mobile number:&nbsp;</p>
                                                    <p className="font-medium">{item.mobile}</p>
                                                </div>
                                            </div>
                                            <div className="flex justify-end gap-4 mt-4">
                                                <button
                                                    onClick={() => handleRemove(item.id)}
                                                    className="border-2 text-[#BB002D] rounded text-sm font-medium px-3 py-1 flex items-center gap-1"
                                                >
                                                    Remove <MdDeleteForever className="size-5" />
                                                </button>
                                            </div>
                                        </label>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <ToastContainer autoClose={1500} />
        </div>
    );
}
